<template>
  <div class="team-permission-button">
    <div
      v-if="disabled"
      class="disabled"
    >
      Disabled
    </div>
    <DpplSubMenu
      v-if="!disabled && user.status === 'active'"
      :margin="false"
      :selected-option="selectedOption"
      :sub-menu-options="subMenuOptions"
      :loading="loading"
      :disabled="!canAdmin && user.status === 'active'"
      :should-open-on-hover="false"
      reduce-font-size
      :chip-height="28"
      @submit-sub-menu="(value) => $emit('submitSubMenu', isJobNavPermission
        ? { role: value, id: user.id }
        : { action: value, id: user.id })
      "
    />
  </div>
</template>

<script>
import { mapState } from 'pinia';
import { useAppAuthData } from '@/stores/app/authData';
import DpplSubMenu from '@/components/datapeople/DpplSubMenu.vue';

const JP_ROLES = ['viewer', /* 'reviewer', */ 'editor', 'operator', 'admin'];

export default {
  name: 'TeamPermissionButtons',
  components: {
    DpplSubMenu,
  },
  props: {
    user: { type: Object, default: () => ({}) },
    disabled: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    canTeamAdmin: { type: Boolean, default: true },
    status: { type: String, default: 'inactive' },
    isJobNavPermission: { type: Boolean, default: false },
  },
  emits: ['submitSubMenu'],
  computed: {
    ...mapState(useAppAuthData, ['authData']),
    canAdmin() {
      if (this.isJobNavPermission) {
        return Boolean(this.authData?.rbac?.permissions?.manageJobNavPermission);
      }
      return this.canTeamAdmin;
    },
    selectedOption() {
      if (this.isJobNavPermission) {
        const role = this.user.jpRole;
        return role ? role.charAt(0).toUpperCase() + role.slice(1) : 'Viewer';
      }
      if (this.user.status === 'active' && this.user.isAdmin) {
        return 'Admin';
      }
      return 'Editor';
    },
    subMenuOptions() {
      if (this.user.status !== 'active') return [];
      if (this.isJobNavPermission) {
        const current = this.user.jpRole || 'viewer';
        return JP_ROLES
          .filter((r) => r !== current)
          .map((r) => ({ id: r, value: r.charAt(0).toUpperCase() + r.slice(1) }));
      }
      return this.user.isAdmin
        ? [{ id: 'revoke', value: 'Editor' }]
        : [{ id: 'grant', value: 'Admin' }];
    },
  },
};
</script>

<style lang="less" scoped>
.team-permission-button {
  display: flex;
  align-items: center;
}
.disabled {
  font-size: 12px;
  font-weight: 500;
  line-height: 150%;
  pointer-events: none;
  opacity: 0.4;
}
</style>
